/** Admin → Location Service → Audit log: every change made in this store's consoles (who, what, when, outcome) —
 * Location Service actions, Super Admin switches, and admin / merchant / rider API changes. Only this store's. */
import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { Empty, ErrorBox, Loading, PageHead, Pill, ResponsiveList, errText, inputCls } from "./LseUI";

export default function LseAudit() {
    const [source, setSource] = useState("");
    const [action, setAction] = useState("");
    const [rows, setRows] = useState(null);
    const [err, setErr] = useState(null);
    useEffect(() => {
        const h = setTimeout(() => {
            setErr(null);
            const qs = new URLSearchParams({ limit: "300" });
            if (source) qs.set("source", source);
            if (action) qs.set("action", action);
            api.get(`/admin/lse/audit?${qs}`).then(({ data }) => setRows(data.entries || [])).catch((e) => setErr(errText(e)));
        }, 250);
        return () => clearTimeout(h);
    }, [source, action]);
    return (
        <div data-testid="lse-audit">
            <PageHead title="Audit log" sub="Newest first. Recorded with the person, their role and whether the change succeeded." />
            <div className="mt-3 flex gap-2 flex-wrap">
                <select className={`${inputCls} !w-auto`} value={source} onChange={(e) => setSource(e.target.value)} aria-label="Source">
                    <option value="">All sources</option><option value="LSE">Location Service</option><option value="API">Console changes</option><option value="SUPER_ADMIN">Super Admin</option>
                </select>
                <input className={`${inputCls} !w-auto`} placeholder="Action starts with…" value={action} onChange={(e) => setAction(e.target.value)} />
            </div>
            {err && <ErrorBox message={err} />}
            {!rows && !err && <Loading />}
            {rows?.length === 0 && <Empty>Nothing recorded yet.</Empty>}
            {rows?.length > 0 && (
                <ResponsiveList testid="lse-audit-list" rows={rows} rowKey={(r) => `${r.ts}-${r.action}-${r.actor_user_id}`}
                    columns={[
                        { key: "ts", label: "When", render: (r) => new Date(r.ts).toLocaleString("en-IN", { dateStyle: "short", timeStyle: "medium" }) },
                        { key: "who", label: "Who", render: (r) => <span>{r.actor_name} <span className="text-muted-foreground text-xs">{(r.actor_role || "").toLowerCase().replace(/_/g, " ")}</span></span> },
                        { key: "action", label: "Action", render: (r) => <span className="font-mono text-xs break-all">{r.action}</span> },
                        { key: "target", label: "On", render: (r) => r.target_label || r.target_id || "—" },
                        { key: "ok", label: "", render: (r) => (r.meta?.ok === false ? <Pill tone="red">{r.meta.status}</Pill> : r.source ? <Pill>{r.source.toLowerCase()}</Pill> : null) },
                    ]}
                    card={(r) => (<div><p className="font-mono text-xs break-all">{r.action}</p><p className="text-xs text-muted-foreground">{r.actor_name} · {new Date(r.ts).toLocaleString("en-IN", { dateStyle: "short", timeStyle: "short" })}{r.target_label ? ` · ${r.target_label}` : ""}</p></div>)} />
            )}
        </div>
    );
}
